/**
 * Helper function to get the correct data array based on currentPage
 * @param {*} state
 * @param {*} response
 * @returns Array
 */
export const getFailedProductListData = (state, response) => {
  // If it's the first page, return an empty array to show the "no product found" message.
  if (response.currentPage === 0) return [];

  // For failed cases on subsequent pages, there is no new data in the response.
  // Return the existing data from the state to avoid affecting already loaded pages.
  return state?.details?.data || [];
};
